export default __webpack_public_path__ + "a1f7822c4d65f7c837a113b331804f3c.png";